import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ size = 40, withText = true, className = "" }) {
  return (
    <Link to="/" className={`oneworld-lockup ${className}`} data-testid="logo-link" aria-label="DetailAcademy von OneWorld – Startseite">
      <img
        src="/brand/oneworld-logo.png"
        alt="OneWorld"
        width={size * 1.15}
        height={size}
        className="oneworld-logo-mark"
      />
      {withText && (
        <span className="oneworld-lockup-copy" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          <span><b>Detail</b><em>Academy</em></span>
          <small>powered by OneWorld</small>
        </span>
      )}
    </Link>
  );
}
